export default "/_next/static/fonts/tt_norms_pro_extralight_italic-a76328e93cc128db89c07f7559ed0d67.woff";